<template>
  <div class="topic-manage app-region blank-t-v blank-l-h blank-r-h">
    <a-row type="flex" align="bottom" :gutter="[16, 16]" class="mg-normal">
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>话题名称</p>
          </a-col>
          <a-col>
            <a-input placeholder="请输入话题名称" v-model="table.search.name"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>话题状态</p>
          </a-col>
          <a-col>
            <a-select v-model="table.search.status" class="app-block" placeholder="请选择话题状态">
              <a-select-option :value="1">隐藏</a-select-option>
              <a-select-option :value="2">显示</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>所属版块</p>
          </a-col>
          <a-col>
            <a-select v-model="table.search.section" class="app-block" placeholder="请选择所属版块">
              <a-select-option :value="value.id" v-for="value in sectionOptions" :key="value.id">{{value.name}}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8" v-if="isPlatformRole">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>发布社区</p>
          </a-col>
          <a-col>
            <a-select mode="multiple" v-model="table.search.community" class="app-block" placeholder="请选择发布社区">
              <a-select-option :value="value.id" v-for="value in communityOptions" :key="value.id">{{value.name}}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-space>
          <a-button type="primary" @click="searchTable">查询</a-button>
          <a-button @click="resetSearchTable">重置</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-row class="mg-normal">
      <a-col>
        <a-space>
          <a-button type="primary" @click="newTopic()">新增话题</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-table class="mg-normal" :loading="table.loading" :columns="table.columns" :data-source="table.data" rowKey="id" :pagination="table.page" @change="handlePageChange">
      <template slot="status" slot-scope="text, data">
        <a-tag color="blue" v-if="!data.is_hide">显示</a-tag>
        <a-tag v-else>隐藏</a-tag>
      </template>
      <template slot="action" slot-scope="text, data">
        <a-space>
          <template v-if="(!isPlatformRole && data.generate_source === 'platform') || (isPlatformRole && data.generate_source === 'community')">
            <a-button type="link" @click="scanTopic(data)">查看</a-button>
          </template>
          <template v-else>
            <a-button type="link" @click="scanTopic(data)">查看</a-button>
            <a-button type="link" @click="editTopic(data)">编辑</a-button>
            <a-button type="link" @click="enableTopic(data)" v-if="data.is_hide">显示</a-button>
            <a-button type="link" @click="disableTopic(data)" v-else>隐藏</a-button>
          </template>
        </a-space>
      </template>
    </a-table>
    <a-drawer width="50%" :title="drawer.title" :visible="drawer.show" destroy-on-close @close="drawer.show = false">
      <topic-details :community-ids="drawer.communityIds"></topic-details>
    </a-drawer>
  </div>
</template>

<script>
  import CommunityService from '@/io/community.js';
  import TopicService from '@/io/topic.js';
  import SectionService from '@/io/section.js';
  import TopicDetails from '@/views/community/TopicDetails.vue';

  export default {
    name: 'TopicManage',
    data() {
      let self = this;
      return {
        table: {
          loading: false,
          search: {
            name: null,
            status: [],
            section: [],
            community: []
          },
          page: {
            total: 0,
            current: 1,
            pageSize: 10,
            showQuickJumper: true,
            showSizeChanger: true,
            showTotal() {
              return `共${self.table.page.total}条`;
            }
          },
          data: [],
          columns: [
            {
              title: '话题名称',
              dataIndex: 'content'
            },
            {
              title: '所属版块',
              dataIndex: 'category_name'
            },
            {
              title: '发布时间',
              dataIndex: 'created_at'
            },
            {
              title: '来源',
              dataIndex: 'sourceText'
            },
            {
              title: '状态',
              scopedSlots: { customRender: 'status' },
            },
            {
              title: '操作',
              scopedSlots: { customRender: 'action' },
            }
          ]
        },
        communityOptions: [],
        sectionOptions: [],
        drawer: {
          id: null,
          communityIds: [],
          title: '话题详情',
          show: false,
        }
      }
    },
    components: {
      TopicDetails,
    },
    activated() {
      Promise.all([
        this.initCommunity(),
        this.initSection()
      ]).then(() => {
        this.initData();
      });
    },
    methods: {
      scanTopic(data) {
        this.drawer.communityIds = data.community_ids;
        this.drawer.show = true;
      },
			// 添加
      newTopic() {
        this.table.page.current = 1;
        this.$router.push({
          name: 'NewTopic'
        });
      },
			// 修改
      editTopic(data) {
        this.$router.push({
          name: 'EditTopic',
          params: {
            id: data.id
          }
        });
      },
			// 显示
      enableTopic(data) {
        TopicService.enable(data.id).then(res => {
          this.initData();
        }).catch(err => {});
      },
			// 隐藏
      disableTopic(data) {
        TopicService.disable(data.id).then(res => {
          this.initData();
        }).catch(err => {});
      },
			// 搜索
      searchTable() {
        this.table.page.current = 1;
        this.initData();
      },
			// 重置
      resetSearchTable() {
        this.table.search = {
          name: null,
          status: [],
          section: [],
          community: []
        };
        this.searchTable();
      },
      handlePageChange(page) {
        this.table.page.current = page.current;
        this.table.page.pageSize = page.pageSize;
        this.initData();
      },
			// 板块数据
      initSection() {
        return SectionService.list().then(res => {
          this.sectionOptions = res;
        }).catch(err => {});
      },
			// 社区数据
      initCommunity() {
        return CommunityService.listPage().then(res => {
          this.communityOptions = res;
        }).catch(err => {});
      },
			// 话题分页列表
      initData() {
        this.table.loading = true;
        TopicService.listPage(
          this.table.search.name,
          this.table.search.status,
          this.table.search.section,
          this.table.search.community,
          this.table.page.current,
          this.table.page.pageSize
        ).then(res => {
          this.table.data = res.data.map(val => {
            if (val.generate_source === 'platform') {
              val.sourceText = '平台';
            } else {
              this.communityOptions.forEach(m => {
                if (m.id === val.community_id) {
                  val.sourceText = m.name;
                }
              });
            }
            return val;
          });
          this.table.page.total = res.meta.pagination.total;
        }).catch(err => {}).finally(() => {
          this.table.loading = false;
        });
      }
    },
  }
</script>

<style lang="less" scoped>

</style>